import axios from 'axios';
import {React, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { WebService } from '../../services/webService';
import Swal from 'sweetalert2';

const Blog = () => {

   const [blog,setBlog] = useState();

const getBlog = async () => {
   try {
      const data = await WebService.getBlogHome();
      setBlog(data || []);
   } catch (error) {
      Swal.fire({
         icon: "error",
         title: "Error!",
         text: "No se pudo cargar la información del blog",
         confirmButtonColor: "#147B9C",
      });
   }
};
   useEffect(() => {
      getBlog();
   }, []);

   return (
      <>
         <div className="animated fadeIn" >
            <div className="container section">
               <div className="row">
                  {blog?.map((b,index) => {
                     return(
                        <div className="col s12 m4 l4 x4">
                           <div className="card">
                              <div className="card-image">
                                 <img src={`/app.latitud/img/blog/${b.blog_img}`} alt={b.blog_titulo}/>
                              </div>
                              <div className="card-content">
                              <span className="card-title" style={{"color": "#00b0ff", "font-size": "13px"}}>{b.blog_etiqueta}</span>
                                    <strong>{b.blog_titulo}</strong>
                              </div>
                           </div>
                        </div>
                     )
                  })}
               </div>
               <div className="row center">
                  <Link to={"blog"} className="btn btn-large waves-effect waves-light btn light-blue accent-3  white pulse" type="submit" name="action">Leer más</Link>
               </div>
            </div>
         </div>

      </>
   )
}

export default Blog